// extracted by mini-css-extract-plugin
export var spinner = "MarketoForm-module--spinner--16Ew5";
export var rotate = "MarketoForm-module--rotate--31Die";
export var fadeOut = "MarketoForm-module--fade-out--1vtAw";
export var fadeIn = "MarketoForm-module--fade-in--u-0vc";
export var marketoForm = "MarketoForm-module--marketo-form--3kC2G";
export var singleCol = "MarketoForm-module--single-col--3s7Vv MarketoForm-module--marketo-form--3kC2G";
export var isNewDemo = "MarketoForm-module--is-new-demo--3aAzp MarketoForm-module--marketo-form--3kC2G";
export var marketoFormSuccess = "MarketoForm-module--marketo-form-success--1y_8s";